import React from "react";
import { useParams } from "react-router-dom";
import { useFetchLoans } from "../../hooks/fetch-data/useFetchLoans";
import LoanDetail from "./LoanDetail";

const LoanDetailPage = () => {
  const { productId } = useParams();

  const { data: loans, isFetching: isFetchingLoans } = useFetchLoans();

  const loanInfo = loans?.find((loan) => loan.id === parseInt(productId));

  return <LoanDetail loanInfo={loanInfo} isFetchingLoans={isFetchingLoans} />;
};

export default LoanDetailPage;
